import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-restricciones-conceptos-dialog",
  standalone: false,
  templateUrl: "./restricciones-conceptos-dialog.component.html",
  styleUrl: "./restricciones-conceptos-dialog.component.scss",
})
export class RestriccionesConceptosDialogComponent {
  errorList = [];
  isError = true;
  isWarning = false;
  isWithRestricciones = false;
  message: string = "";
  listRestricciones: any[] = [];
  isListadoRestricciones: false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { error; isError; message; isWarning; isWithRestricciones, listRestricciones, isListadoRestricciones },
    public dialogRef: MatDialogRef<any>,
  ) {
    if (typeof data.error !== "string") {
      this.errorList = data.error;
    }

    this.isError = data.isError;
    this.isWarning = data.isWarning;
    this.isWithRestricciones = data.isWithRestricciones;
    this.message = data.message || "";
    this.listRestricciones = data.listRestricciones || [];
    this.isListadoRestricciones = data.isListadoRestricciones;
  }

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close({ event: 2 });
  }

  save() {
    this.dialogRef.close({ event: 1 });
  }
}
